import { InjectionToken } from '@angular/core';
import { AssistantDataService } from './assistant-data.service';

export const ASSISTANT_DATA_SERVICE = new InjectionToken<AssistantDataService>('ASSISTANT_DATA_SERVICE');
